
import * as React from 'react'

type Props = {
  leftSwipeCallback?: (() => void),
  rightSwipeCallback?: (() => void),
  upSwipeCallback?: (() => void),
  downSwipeCallback?: (() => void),
  threshold?: number,
  className?: string,
  children: React.ReactNode
}

type State = {
  touchStartX: number,
  touchStartY: number
}

export default class Swipe extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      touchStartX: 0,
      touchStartY: 0
    }

    this.handleTouchStart = this.handleTouchStart.bind(this) as this['handleTouchStart']
    this.handleTouchEnd = this.handleTouchEnd.bind(this) as this['handleTouchEnd']
  }

  handleTouchStart = (touchDownEvent: React.TouchEvent<HTMLDivElement>) => {
    touchDownEvent.preventDefault()
    this.setState({
      touchStartX: touchDownEvent.targetTouches[0].clientX,
      touchStartY: touchDownEvent.targetTouches[0].clientY
    })
  }

  handleTouchEnd = (touchEndEvent: React.TouchEvent<HTMLDivElement>) => {
    const { leftSwipeCallback, rightSwipeCallback, upSwipeCallback, downSwipeCallback } = this.props
    const threshold = this.props.threshold || 100
    const deltaX = touchEndEvent.changedTouches[0].clientX - this.state.touchStartX
    const deltaY = touchEndEvent.changedTouches[0].clientY - this.state.touchStartY

    if (deltaX < (threshold * -1) && leftSwipeCallback) leftSwipeCallback()
    if (deltaX > threshold && rightSwipeCallback) rightSwipeCallback()
    if (deltaY > threshold && downSwipeCallback) downSwipeCallback()
    if (deltaY < (threshold * -1) && upSwipeCallback) upSwipeCallback()

    this.setState({
      touchStartX: 0,
      touchStartY: 0
    })
  }

  render () {
    return (
      <div className={`swipe ${this.props.className || ''}`}
        onTouchStart={this.handleTouchStart}
        onTouchEnd={this.handleTouchEnd}>
        {this.props.children}
      </div>
    )
  }
}
